import React, { useState } from 'react';
import '../styles/contactus.css';

const ENQUIRY_TYPES = [
  'General Enquiry',
  'Project Quotation',
  'Technical Support',
  'Partnership / Distribution',
];

const ContactUs: React.FC = () => {
  const [form, setForm] = useState({ name: '', company: '', email: '', phone: '', type: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Server error');
      setStatus('sent');
      setForm({ name: '', company: '', email: '', phone: '', type: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="cv-contact">
      <div className="cv-container">
        <div className="cv-section-header cv-section-header--light">
          <span className="cv-section-tag cv-section-tag--light">Get In Touch</span>
          <h2 className="cv-section-title cv-section-title--light">Ready to Start Your Project?</h2>
          <p className="cv-section-subtitle cv-section-subtitle--light">
            Contact our team for a consultation, project quotation, or to learn more about our
            monitoring solutions.
          </p>
        </div>

        <div className="cv-contact__grid">
          <div className="cv-contact__info">
            <div className="cv-contact__info-block">
              <h3>CoreVision Pte Ltd</h3>
              <p>Registered in Singapore (UEN: 202418575H)</p>
            </div>
            <div className="cv-contact__info-item">
              <span className="cv-contact__info-icon" aria-hidden="true">📍</span>
              <div className="cv-contact__info-content">
                <strong>Office</strong>
                <p>65 Ubi Crescent, #03-05<br />Hola Centre, Singapore 408559</p>
              </div>
            </div>
            <div className="cv-contact__info-item">
              <span className="cv-contact__info-icon" aria-hidden="true">☎</span>
              <div className="cv-contact__info-content">
                <strong>Phone</strong>
                <p><a href="tel:+6568968926">+65 6896 8926</a><br /><a href="tel:+6591689666">+65 9168 9666</a></p>
              </div>
            </div>
            <div className="cv-contact__info-item">
              <span className="cv-contact__info-icon" aria-hidden="true">✉</span>
              <div className="cv-contact__info-content">
                <strong>Email</strong>
                <p><a href="mailto:enquire@corevision.com.sg">enquire@corevision.com.sg</a></p>
              </div>
            </div>
            <div className="cv-contact__info-item">
              <span className="cv-contact__info-icon" aria-hidden="true">🕒</span>
              <div className="cv-contact__info-content">
                <strong>Office Hours</strong>
                <p>Mon - Fri: 8:30 AM - 6:00 PM<br />Sat: By appointment</p>
              </div>
            </div>
          </div>

          <form className="cv-contact__form" onSubmit={handleSubmit}>
            <div className="cv-form-row">
              <div className="cv-form-group">
                <label htmlFor="name">Full Name *</label>
                <input id="name" name="name" type="text" value={form.name} onChange={handleChange} required placeholder="Your full name" />
              </div>
              <div className="cv-form-group">
                <label htmlFor="company">Company / Organisation *</label>
                <input id="company" name="company" type="text" value={form.company} onChange={handleChange} required placeholder="Your company" />
              </div>
            </div>
            <div className="cv-form-row">
              <div className="cv-form-group">
                <label htmlFor="email">Email Address *</label>
                <input id="email" name="email" type="email" value={form.email} onChange={handleChange} required placeholder="you@company.com" />
              </div>
              <div className="cv-form-group">
                <label htmlFor="phone">Phone Number</label>
                <input id="phone" name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="+65 XXXX XXXX" />
              </div>
            </div>
            <div className="cv-form-group">
              <label htmlFor="type">Enquiry Type *</label>
              <select id="type" name="type" value={form.type} onChange={handleChange} required>
                <option value="">Select enquiry type</option>
                {ENQUIRY_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="cv-form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={5}
                placeholder="Describe your project or enquiry..."
              />
            </div>

            {status === 'sent' && (
              <div className="cv-form-success">
                Thank you. We will respond within 1 business day.
              </div>
            )}
            {status === 'error' && (
              <div className="cv-form-error">
                Something went wrong. Please email us directly at enquiry@corevision.com.sg
              </div>
            )}

            <button type="submit" className="cv-btn cv-btn--submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending...' : 'Send Enquiry'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
